module.exports = __webpack_public_path__ + "img/54_7.4f34ef2b.png";